export default "__VITE_ASSET__BPC01ZuR__"